import { get } from "lodash";
import { ERROR, SUCCESS, WARNING } from "./constants";

export const loading = (state) => get(state, "general.loading", false);
export const success = (state) => get(state, "general.success", false);
export const error = (state) => get(state, "general.error", false);
export const warning = (state) => get(state, "general.warning", false);
export const message = (state) => get(state, "general.message", null);
export const getAlertType = (state) => {
  const types = [
    { name: SUCCESS, value: success(state) },
    { name: ERROR, value: error(state) },
    { name: WARNING, value: warning(state) },
  ];
  return types.find((type) => type.value)?.name;
};
